import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "label"]

  connect() {
    this._closeOnClickOutside = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
  }

  toggle() {
    const open = this.dropdownTarget.classList.toggle("comment-filter-dropdown--open")
    if (open) {
      document.addEventListener("click", this._closeOnClickOutside)
    } else {
      document.removeEventListener("click", this._closeOnClickOutside)
    }
  }

  close() {
    this.dropdownTarget.classList.remove("comment-filter-dropdown--open")
    document.removeEventListener("click", this._closeOnClickOutside)
  }

  select(event) {
    const title = event.currentTarget.querySelector(".comment-filter-dropdown__title").textContent
    this.labelTarget.textContent = title
    this.close()
  }

  disconnect() {
    document.removeEventListener("click", this._closeOnClickOutside)
  }
}
